import type { JSX } from 'react';
import { PENDING_LABEL } from '../labels';
import { Skeleton } from './ui/skeleton';

/**
 * A panel whose request is still in flight — the other half of the gate {@link ErrorNote} owns.
 * Two shapes, one word: {@link PendingNote} waits where the geometry is unknown, {@link PendingShape}
 * draws the panel's own size where it is known, so the page stops jumping (§6 row 18). The word is
 * not dropped for the box — the shape carries it as its accessible name.
 */
export function PendingNote(): JSX.Element {
  return <p className="chart-status muted">{PENDING_LABEL}</p>;
}

export function PendingShape({ className }: { className?: string }): JSX.Element {
  return (
    <div role="status" aria-label={PENDING_LABEL}>
      <Skeleton className={className} />
    </div>
  );
}

/** The feed's own wait: three cards' worth of rows, so the list does not appear out of nothing. */
export function PendingFeed(): JSX.Element {
  return (
    <div role="status" aria-label={PENDING_LABEL} className="flex flex-col gap-4">
      {[0, 1, 2].map((row) => (
        <Skeleton key={row} className="h-24 w-full" />
      ))}
    </div>
  );
}
